import type { DocumentTypeConfig } from "../types";

export const riskAnalysisConfig: DocumentTypeConfig = {
  documentType: "risk_analysis",
  supportedFormats: ["xlsx", "pdf"],
  xlsx: {
    version: {
      cell: "P4",
      sheetName: "Instructiuni utilizare",
      sheetIndex: 1,
      expectedVersions: ["v2_46055", "V1.3", "V1.2", "V1.1", "V1.0"],
    },
    sheets: [
      {
        sheetName: "Date entitate",
        sheetIndex: 2,
        mappings: [
          {
            cell: "D8",
            field: "denumire_entitate",
            valueType: "string",
            required: true,
          },
          { cell: "D9", field: "cui", valueType: "string", required: true },
          { cell: "D10", field: "judet", valueType: "string", required: false },
          {
            cell: "D11",
            field: "localitate",
            valueType: "string",
            required: false,
          },
          {
            cell: "D12",
            field: "sector",
            valueType: "string",
            required: false,
          },
          {
            cell: "D13",
            field: "dimensiune",
            valueType: "string",
            required: false,
          },
          {
            cell: "D16",
            field: "reprezentant_legal",
            valueType: "string",
            required: false,
          },
          {
            cell: "D17",
            field: "functia",
            valueType: "string",
            required: false,
          },
          { cell: "D18", field: "data", valueType: "string", required: false },
        ],
      },
      {
        sheetName: "Lista de sectoare",
        sheetIndex: 3,
        mappings: [
          {
            cell: "D10",
            field: "sector_101",
            valueType: "string",
            required: false,
          },
          {
            cell: "D11",
            field: "sector_102",
            valueType: "string",
            required: false,
          },
          {
            cell: "D12",
            field: "sector_103",
            valueType: "string",
            required: false,
          },
          {
            cell: "D13",
            field: "sector_104",
            valueType: "string",
            required: false,
          },
          {
            cell: "D14",
            field: "sector_105",
            valueType: "string",
            required: false,
          },
          {
            cell: "D15",
            field: "sector_106",
            valueType: "string",
            required: false,
          },
          {
            cell: "D16",
            field: "sector_107",
            valueType: "string",
            required: false,
          },
          {
            cell: "D17",
            field: "sector_108",
            valueType: "string",
            required: false,
          },
          {
            cell: "D18",
            field: "sector_109",
            valueType: "string",
            required: false,
          },
          {
            cell: "D19",
            field: "sector_110",
            valueType: "string",
            required: false,
          },
          {
            cell: "D20",
            field: "sector_111",
            valueType: "string",
            required: false,
          },
          {
            cell: "D21",
            field: "sector_201",
            valueType: "string",
            required: false,
          },
          {
            cell: "D22",
            field: "sector_202",
            valueType: "string",
            required: false,
          },
          {
            cell: "D23",
            field: "sector_203",
            valueType: "string",
            required: false,
          },
          {
            cell: "D24",
            field: "sector_204",
            valueType: "string",
            required: false,
          },
          {
            cell: "D25",
            field: "sector_205",
            valueType: "string",
            required: false,
          },
          {
            cell: "D26",
            field: "sector_206",
            valueType: "string",
            required: false,
          },
        ],
      },
      // Sector risk matrix sheets ("101_Energie" through "207_Cercetare") have identical structure
      // and are handled dynamically in the extractor/transformer, not as static cell mappings here.
    ],
  },
};
